//Models
PJQ.models.profile = {};

PJQ.models.profile.CompanyProfile = PJQ.models.BaseModel.extend({
	idAttribute: 'profileKey',
	defaults: {
		isFileAPI: true
	},
	defaultTheme: {
		headerBackgroundColor: '#495057',
		navMenuTextColor: '#0071E6',
		sectionHeaderTextColor: '#495057',
		sectionBodyTextColor: '#6c757d'
	},
	endpoint: function () {
		if (!this.get('canEdit')) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'profiles',
					value: this.get('profileKey')
				}
			]);
		}
		else {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'profiles'
				}
			]);
		}
	},
	parse: function (model) {
		model = model ? model : {};

		model.theme = _.defaults(model && model.theme ? model.theme : {}, this.defaultTheme);

		if (this.groups == null) {
			this.groups = new PJQ.collections.groups.Groups(model.groups, {
				groupLevels: 2
			});
		}
		else {
			this.groups.reset(_.size(model.groups) > 0 ? model.groups : null);
			this.groups.options.groupLevels = 2;
		}

		if (this.projectReferences) {
			this.projectReferences.reset(model.projectReferences);
		}
		else {
			this.projectReferences = new PJQ.collections.prequal.ProjectReferences(model.projectReferences);
		}

		if (this.companyPhotos) {
			this.companyPhotos.reset(model.companyPhotos);
		}
		else {
			this.companyPhotos = new PJQ.collections.contacts.CompanyPhotos(model.companyPhotos);
		}

		return model;
	},
	beforeSave: function () {
		this.set('projectReferences', this.projectReferences.toJSON());
		this.set('companyPhotos', this.companyPhotos.toJSON());
	},
	restoreDefaultTheme: function () {
		this.set('theme', this.defaultTheme);
	}
});